import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Divider,
    Stack,
    Flex,
    Text,
    useMultiStyleConfig,
    useBreakpointValue,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import PaymentIcons from './payment-icons'
import SocialIcons from '../social-icons'
import CountrySelector from '../../components/footer/country-selector'
import LegalLinks from './legal-links'
import ApplicationIcons from './application-icons'
import BrandLogo from '../icons/shared/logo'
import useUtils from '../../custom-hooks/use-utils-helper'
import {useLocation} from 'react-router-dom'

const CopyrightSection = ({data}) => {
    const styles = useMultiStyleConfig('Footer')

    const intl = useIntl()

    const location = useLocation()
    const {isCheckout, isCart, isMaintenance} = useUtils().currentPage(location.pathname)
    const isFooterLite = isCart || isCheckout || isMaintenance

    const footerData = data?.footer_bottom_group

    const copyrightGroup = footerData?.copyright_group
    const copyright = copyrightGroup?.copyright
    const vatNumber = copyrightGroup?.vat_number

    const breakpoint = useBreakpointValue({
        base: null,
        sm: 'sm',
        lg: 'lg',
    })

    return (
        <>
            {breakpoint === 'lg' && (
                <Box w="100%" {...styles.hideOnMobile}>
                    {!isFooterLite && <Divider {...styles.dividerRule} />}
                    <Flex {...styles.paymentsLegal}>
                        <Stack {...styles.countryPayments}>
                            <Flex {...styles.brandCountry}>
                                <BrandLogo
                                    data-testid="brand-logo"
                                    inverted={true}
                                    {...styles.footerBrand}
                                />

                                {!isFooterLite && <CountrySelector intl={intl} />}
                                {!isFooterLite && (
                                    <Text {...styles.copyright} data-testid="copyright">
                                        {`${copyright} ${vatNumber}`}
                                    </Text>
                                )}
                            </Flex>
                            {!isFooterLite && (
                                <PaymentIcons
                                    data-testid="payment-icons"
                                    icons={footerData?.payment_icons}
                                />
                            )}
                        </Stack>
                        <Stack {...styles.socialAppPrivacyContainer}>
                            {!isFooterLite && (
                                <Stack {...styles.socialAppPrivacy}>
                                    <Flex {...styles.socialApp}>
                                        <SocialIcons
                                            data-testid="social-icons"
                                            icons={footerData?.social_icons}
                                        />

                                        <ApplicationIcons icons={footerData?.app_download_icons} />
                                    </Flex>
                                </Stack>
                            )}
                            {/* Add LegalLinks here to align horizontally */}
                            <Box>
                                <LegalLinks
                                    variant="horizontal"
                                    data-testid="legal-links"
                                    links={copyrightGroup?.copyright_links}
                                >
                                    <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                                </LegalLinks>
                            </Box>
                        </Stack>
                    </Flex>
                </Box>
            )}
            {breakpoint === 'sm' && !isFooterLite && (
                <Box w="100%" {...styles.hideOnDesktop}>
                    <Stack {...styles.mobileStack} {...styles.mobileContainer}>
                        <SocialIcons data-testid="social-icons" icons={footerData?.social_icons} />
                        <Flex {...styles.mobileLogoCoutry}>
                            <BrandLogo
                                data-testid="brand-logo"
                                inverted={true}
                                {...styles.footerBrand}
                            />
                            {!isFooterLite && <CountrySelector intl={intl} />}
                        </Flex>
                        <ApplicationIcons icons={footerData?.app_download_icons} />

                        <PaymentIcons
                            data-testid="payment-icons"
                            icons={footerData?.payment_icons}
                        />
                    </Stack>
                </Box>
            )}
            {breakpoint === 'sm' && (
                <Box w="100%" {...styles.copyPositioning}>
                    <LegalLinks
                        variant="horizontal"
                        data-testid="legal-links"
                        links={copyrightGroup?.copyright_links}
                    >
                        <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                    </LegalLinks>
                    {!isFooterLite && (
                        <Text data-testid="copyright" {...styles.copyright}>
                            {`${copyright} ${vatNumber}`}
                        </Text>
                    )}
                </Box>
            )}
        </>
    )
}

CopyrightSection.propTypes = {
    data: PropTypes.shape({
        footer_bottom_group: PropTypes.shape({
            copyright_group: PropTypes.shape({
                copyright: PropTypes.string,
                vat_number: PropTypes.string,
                copyright_links: PropTypes.array,
            }),
            payment_icons: PropTypes.array,
            social_icons: PropTypes.array,
            app_download_icons: PropTypes.array,
        }),
    }),
}

export default CopyrightSection
